import { Box, Flex, HStack, useToast } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { BsChevronRight } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import RegisterLine from "../trainee/register/RegisterLine";
import AdminDashboardHeader from "./AdminHeader";
import AdminSidebar from "./AdminSidebar";
import EditCourseInfo from "./course/editcourse/editCourseInfo";
import EditCurriculumInfo from "./course/editcourse/editCurriculumInfo";
// import AdminDashboardHeader from "../../../components/admin/AdminHeader";
// import AdminAdditionalInfo from "./course/newcourse/AdditionalInfo";
// import Certification from "./trainee/register/Certification";
// import EducationProfile from "../../../components/trainee/register/EducationProfile";
// import KitSize from "../../../components/trainee/register/KitSize";
// import BasicDetails from "../../../components/trainer/BasicDetails";

const AdminEditCourse = () => {
  const [gender, setGender] = useState<any[]>([]);
  const navigate = useNavigate();

  const [pageState, setPagestate] = useState(0);
  const toast = useToast();

  const [courseTitle, setCourseTitle] = useState<string>();

  const pages = [
    { index: 1, component: EditCourseInfo },
    { index: 2, component: EditCurriculumInfo },
  ];

  const switchPage = () => {
    const Component = pages[pageState].component;
    return <Component nextPage={nextPage} prePage={prePage} />;
  };

  const nextPage: any = () => {
    if (pageState < pages.length) {
      setPagestate(+pageState);
    }
    localStorage.setItem("naptin_course_page_no", pageState.toString());
  };

  const prePage = () => {
    if (pageState > 0) {
      setPagestate(-pageState);
    }
    localStorage.setItem("naptin_course_page_no", pageState.toString());
  };

  useEffect(() => {
    const pageNo = localStorage.getItem("naptin_course_page_no") ?? "0";

    setPagestate(parseInt(pageNo));
  }, []);

  const clearCourseFromLocalStorage = () => {
    window.location.reload();
  };

  useEffect(() => {
    const maingender = [
      {
        id: "1",
        title: "Technical",
      },
      {
        id: "2",
        title: "Non-Technical",
      },
    ];
    setGender(maingender);
  }, []);

  return (
    <>
      <Flex
        maxHeight={"100vh"}
        height={"auto"}
        boxSizing="border-box"
        maxWidth={"100hw"}
        pb="20px"
      >
        <Box
          width={["3.5rem", "3.5rem", "3.5rem", "20%"]}
          position="relative"
          top="0"
          left="0"
          zIndex="100"
        >
          <AdminSidebar />
        </Box>

        <Box width={"100%"}>
          <AdminDashboardHeader />
          <Flex
            justifyContent="center"
            height="100%"
            bg="#F9F8F8"
            pb="50px"
        
          >
            <Box mt="50px" height="100%" pb="50px"     overflowY={"scroll"} className="scroll-hidden">
              <Box
                height="3rem"
                width={["95%","95%","95%","764px"]}
                bg="white"
                boxShadow="0px 0px 4px rgba(0, 0, 0, 0.08)"
                px={8}
                py={2}
                mx="auto"
              >
                <HStack justifyContent="center" gap="2rem" >
                  <RegisterLine
                    position="1"
                    title="Course/Program Information"
                    bgColor={pageState === 0 ? "#EC3337" : "#FFE1E2"}
                    textColor={pageState === 0 ? "#EC3337" : "brand.subtitle"}
                    fontWeight={pageState === 0 ? "700" : "400"}
                  />

                  {/* <BsChevronRight />

                  <RegisterLine
                    position="2"
                    title="Curriculum"
                    bgColor={pageState === 1 ? "#EC3337" : "#FFE1E2"}
                    textColor={pageState === 1 ? "#EC3337" : "brand.subtitle"}
                    fontWeight={pageState === 1 ? "700" : "400"}
                  /> */}
                </HStack>
              </Box>
              <Box
                boxShadow="base"
                width={["95%","95%","95%","764px"]}
                bg="white"
                mb="50px"
                mt={6}
                py={4}
                px={8}
                mx="auto"
              >
                {switchPage()}
              </Box>
            </Box>
          </Flex>
        </Box>
      </Flex>
    </>
  );
};

export default AdminEditCourse;
